import React from "react";
import classes from './BackdropPopup.module.css'

const BackdropPopup = ({ children, myHeight, myWidth, minHeight }) => {

    return (
        <div className={classes.BackdropPopupContainer}>
            <div className={classes.BackdropPopup} style={{ height: myHeight ? myHeight : '316px', width: myWidth ? myWidth : '482px' ,minHeight: minHeight ?minHeight:'' }}>
                {children}
            </div>
        </div>
    )
}

export default BackdropPopup;